var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { generateQueryParamsStr } from "../../utils/apiUtils";
const EXPENSES_API = "api/expenses";
export const updateById = function (expenseId, storeId, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` },
            };
            const query = generateQueryParamsStr(["storeId"], { storeId });
            return yield this.axiosInstance.patch(`${EXPENSES_API}/${expenseId}?${query}`, data, config);
        }
        catch (error) {
            console.error("Error fetching expenses updateById:", error);
            throw error;
        }
    });
};
